export default __webpack_public_path__ + "static/media/13_FeedBack.b6ca9b4c.png";